import { Mutation } from "@apollo/client/react/components";
import React from "react";
import SetGovernmentAwards from "~/lib/mutations/SetGovernmentAwards";
import AwardsBox from "~/components/awards/AwardsBox";
import { IGovernmentQuery } from "~/lib/queries/__generated__/GovernmentQuery.generated";
import {
  ISetGovernmentAwardsMutation,
  ISetGovernmentAwardsMutationVariables,
} from "~/lib/mutations/__generated__/SetGovernmentAwards.generated";

interface IGovernmentAwardsProps {
  government: NonNullable<IGovernmentQuery["government"]>;
  onAddLink: () => void;
}

export default function GovernmentAwards({ government, onAddLink }: IGovernmentAwardsProps) {
  return (
    <Mutation<ISetGovernmentAwardsMutation, ISetGovernmentAwardsMutationVariables> mutation={SetGovernmentAwards}>
      {(setAwards) => (
        <AwardsBox
          onAddLink={onAddLink}
          awards={government.awards}
          readOnly={!government.viewerIsMember}
          onSubmit={(values) => {
            return setAwards({
              variables: {
                governmentId: government._id,
                awards: values.awards.map(({ _id, objectID }: any) => _id || objectID),
              },
              optimisticResponse: {
                __typename: "Mutation",
                setGovernmentAwards: {
                  __typename: "Government",
                  _id: government._id,
                  awards: values.awards.map(({ _id, objectID, name }: any) => ({
                    _id: _id || objectID,
                    name,
                  })),
                },
              },
            });
          }}
        />
      )}
    </Mutation>
  );
}
